import { render, staticRenderFns } from "./BuildingPlannedDates.vue?vue&type=template&id=a0685cf2"
import script from "./BuildingPlannedDates.vue?vue&type=script&lang=js"
export * from "./BuildingPlannedDates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports